import { Ol } from '../../lib/types/models/ol/ol'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterOl(id: number): Promise<Ol> {
  return restApiClient.url(constructApiUrl(API.centers.getCenterOl.url, { id })).get<Ol>()
}
